import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const HEADING_FONT = '"Sora", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

const theme = createTheme({
  palette: {
    mode: 'light',
    // The brand kit: Flo Blue, Ink, Mist. Amber is the mark's accent only, never a UI colour.
    primary: {
      main: '#1F5BFF',
      light: '#5C86FF',
      dark: '#1747CC',
    },
    secondary: {
      main: '#0F1B2D',
      light: '#3A4A63',
      dark: '#0A1220',
    },
    text: {
      primary: '#0F1B2D',
      secondary: '#4A5568',
    },
    divider: '#E6E9EF',
    background: {
      default: '#F3F5F9',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    // Headings in the brand face (self-hosted, see public/index.html); body copy stays in the system face.
    h1: { fontFamily: HEADING_FONT, fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontFamily: HEADING_FONT, fontWeight: 600, letterSpacing: '-0.02em' },
    h3: { fontFamily: HEADING_FONT, fontWeight: 600, letterSpacing: '-0.02em' },
    h4: { fontFamily: HEADING_FONT, letterSpacing: '-0.02em' },
    h5: { fontFamily: HEADING_FONT, letterSpacing: '-0.01em' },
    h6: { fontFamily: HEADING_FONT, letterSpacing: '-0.01em' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          borderRadius: 8,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);